const categories = {
  bets: {
    id: 0,
    textIdent: 'bets',
  },
  myBets: {
    id: 1,
    textIdent: 'myBets',
  },
  results: {
    id: 2,
    textIdent: 'topBets',
  },
}

export { categories };